import { withTaskContext } from "@twilio/flex-ui";
import { ParticipantsTab } from "./ParticipantsTab";

export default withTaskContext(ParticipantsTab);
